export default class Stack {
    
    constructor() {
        this.length = 0;
    }

    push(value) {
        let newPeak = { val: value, prev: this.peak ?? null};
        this.peak = newPeak;
        this.length++;
    }

    pop() {
        if (this.length === 0) {
            throw new Error("Stack is empty");
        }

        let v = this.peak.val;        
        this.length--;
        this.peak = this.length === 0 ? undefined : this.peak.prev;
        return v;        
    }

    pushRange(values) {
        values.reverse().forEach(value => {
            this.push(value);
        });
    }

    * getIterator() {
        let current = this.peak;
        while (current) {
            yield current;
            current = current.prev;
        }
    }

    toArray() {
        let iterator = this.getIterator();
        let a = [];

        for(let cur of iterator) {
            a.push(cur.val);
        }

        return a;
    }

    static fromArray(array) {
        var stack = new Stack();
        stack.pushRange(array);
        return stack;
    }

    clone() {
        return Stack.fromArray(this.toArray());
    }

    toString() {
        return '[' + this.toArray().join(", ") + ']';
    }
}